// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"9de1785c","329":"0bc81a63","697":"fd5c116d","915":"0bc81a63"}[chunkId] + ".chunk.css";
};